import React from 'react';
import {
  NavLink as Link
} from 'react-router-dom'
import './Footer.css';

export default () => {
  return (
    <div className="Footer">
      <span> Copyright 2017 </span> <br/>
      <Link to="/info" activeClassName="hidden"> About </Link>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/component/organisms/Footer/index.js